module.exports = __webpack_public_path__ + "img/gys_1@2x.2313193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_1@2x.png
// module id = ithE
// module chunks = 0